export default "__VITE_ASSET__Xq5e27fX__"